/**
 * Stories for 404 handle this
 */
/* eslint-disable local-rules/require-storybook-documentation */
import { FunctionComponent, useEffect, useRef } from 'react';

export const AsyncCat: FunctionComponent = () => {
    const mountContainerRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        Promise.all([
            import(
                /* webpackChunkName: "cat-animation-library" */
                'lottie-web/build/player/lottie_svg.min'
            ),
            import(
                /* webpackChunkName: "cat-animation-data" */
                './cat-animation-data.json'
            ),
        ]).then(([{ default: lottie }, { default: animationData }]) => {
            lottie.loadAnimation({
                // Cast to HTMLDivElement because we know for a fact that it exists by the time this hook is called
                container: mountContainerRef.current as HTMLDivElement,
                renderer: 'svg',
                loop: false,
                animationData,
            });
        });
    }, []);
    return <div ref={mountContainerRef} />;
};
